export default __webpack_public_path__ + "static/media/clock.45314247.svg";